module.exports = __webpack_public_path__ + "img/Bellhop.932a4034.jpg";